import React, { useState, useEffect } from "react";
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import PauseOutlinedIcon from '@material-ui/icons/PauseOutlined';
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
// maybe use class component for this audio btn
/*
  FOUND THIS ERROR
  7264712_1623542443.mp3:1 
  GET 
  https://naturalvoiceblaster.s3.amazonaws.com/assets/naturalvoiceblaster/7264712_1623542443.mp3 
  net::ERR_CACHE_OPERATION_NOT_SUPPORTED
*/

/**
 * useAudio 
 * @param {string} url 
 * @returns {bool} playing
 */
const useAudio = (url, setAudioPlaying) => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const handlePlayOfAudio = React.useCallback(bool => {
    setPlaying(bool)
    setAudioPlaying(bool)
  }, [setAudioPlaying, setPlaying])

  const audioError = React.useCallback(e => {
    console.error('audio error-->', e)
    audio.currentTime = 0
    alert('audio not avaliable')
    handlePlayOfAudio(false)
  }, [audio, handlePlayOfAudio])

  const toggle = () => {
    handlePlayOfAudio(!playing)
  };

  const restart = () => {
    audio.currentTime = 0
    handlePlayOfAudio(true)
    audio.play().then().catch(audioError)
  }

  useEffect(() => {
    playing
      ? audio.play().then().catch(audioError)
      : audio.pause();
  },
    [playing, audio, audioError]
  );

  useEffect(() => {
    const finishedPlaying = () => {
      setPlaying(false)
      setAudioPlaying(false)
    }
    audio.addEventListener('ended', finishedPlaying);
    return () => {
      audio.removeEventListener('ended', finishedPlaying);
    };
  }, []);

  return [playing, toggle, restart, audio];
};

const AudioBtn = ({ url, audio_playing, setAudioPlaying }) => {
  // clean url, somtimes it comes wth extra quotes we dont want
  url = url.replaceAll('"', '')

  const [playing, toggle, restart, audio] = useAudio(url, setAudioPlaying);
  if (playing) {
    return <span>
      <PauseOutlinedIcon onClick={toggle} />
    </span>
  } else if (audio_playing) {
    return <VolumeOffIcon />
  }
  return <span>
    <VolumeUpIcon onClick={toggle} />
    {audio.currentTime > 0 ? <RefreshOutlinedIcon onClick={restart} /> : <></>}

  </span>
};

export default AudioBtn;
